import { SelectionState } from "@alfresco/adf-extensions";
import { MinimalNodeEntity } from "@alfresco/js-api";
import { Action } from "@ngrx/store";

export enum LoanActionTypes {
    CreateLoan = 'CREATE_LOAN',
    ViewLoan = "VIEW_LOAN",
    ValidateLoan = 'VALIDATE_LOAN',
    EditLoan = 'EDIT_LOAN',
    AssignRegisterLoan = "ASSIGN_REGISTER",
    GrantLoan = "GRANT_LOAN",
    ReturnLoan = "RETURN_LOAN",
    RenewLoan = "RENEW_LOAN",
    ValidateRenewLoan = "VALIDATE_RENEW_LOAN",
    DeleteLoan = 'DELETE_LOAN',
    FinishLoan = 'FINISH_LOAN'
}

export class CreateLoanAction implements Action {
  readonly type = LoanActionTypes.CreateLoan;

  constructor(public payload?: SelectionState) {}
}

export class ViewLoanAction implements Action {
  readonly type = LoanActionTypes.ViewLoan;

  constructor(public payload?: SelectionState) {}
}

export class ValidateLoanAction implements Action {
  readonly type = LoanActionTypes.ValidateLoan;

  constructor(public payload?: SelectionState) {}
}

export class EditLoanAction implements Action {
  readonly type = LoanActionTypes.EditLoan;

  constructor(public payload?: SelectionState) {}
}

export class AssignRegisterLoanAction implements Action {
  readonly type = LoanActionTypes.AssignRegisterLoan;

  constructor(public payload?: SelectionState) {}
}

export class GrantLoanAction implements Action {
  readonly type = LoanActionTypes.GrantLoan;

  constructor(public payload?: SelectionState) {}
}

export class ReturnLoanAction implements Action {
  readonly type = LoanActionTypes.ReturnLoan;

  constructor(public payload?: SelectionState) {}
}

export class RenewLoanAction implements Action {
  readonly type = LoanActionTypes.RenewLoan;

  constructor(public payload?: SelectionState) {}
}

export class ValidateRenewLoanAction implements Action {
  readonly type = LoanActionTypes.ValidateRenewLoan;

  constructor(public payload?: SelectionState) {}
}

export class DeleteLoanAction implements Action {
  readonly type = LoanActionTypes.DeleteLoan;

  constructor(public payload: MinimalNodeEntity[] = []) {}
}

export class FinishLoanAction implements Action {
  readonly type = LoanActionTypes.FinishLoan;

  constructor(public payload: MinimalNodeEntity[] = []) {}
}
